import api from "./api";
import auth from "./auth";

const BASE_SERVICE_URL = "reports-service/v1/cms/reports/store";
const CUSTOMER_BASE_URL = "customer-service/cms/customer/list/";

export default {
    getCustomerMembershipID: function(param, filter = null) {
        return new Promise((resolve, reject) => {
            api.post(CUSTOMER_BASE_URL + param.page,
                filter,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    create: function(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/add",
                param,
                auth.getHeader())
               .then(response => {
                   return resolve(response);
               })
               .catch((status, error) => {
                   reject(status, error);
               });
        });
    },

    update: function(param) {
        return new Promise((resolve, reject) => {
            api.post(BASE_SERVICE_URL + "/update",
                param,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    getList: function(param) {
        return new Promise((resolve, reject) => {
            api.get(BASE_SERVICE_URL + "/list/" + param.membership_id + "/" + param.page,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },

    delete: function(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(BASE_SERVICE_URL + "/delete/" + uuid,
                auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
}